export default "__VITE_ASSET__CpMMB7F$__"